import React, { useState } from "react";
import {
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
} from "@mui/material";
import {
  Image as ImageIcon,
  Close as CloseIcon,
} from "@mui/icons-material";

/**
 * PreviewImageButton - A reusable button component for image preview with full-size popup
 *
 * @param {Object} props
 * @param {string} props.imageUrl - The image URL to be previewed (required)
 * @param {string} props.label - Optional label for the image
 * @param {string} props.color - Button color (default, primary, secondary, etc.)
 * @param {string} props.size - Button size (small, medium, large)
 */
const PreviewImageButton = ({ 
  imageUrl, 
  label = "Image Preview",
  color = "default",
  size = "small"
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (!imageUrl) return null;

  return (
    <>
      <IconButton
        onClick={handleOpen}
        size={size}
        color={color}
        aria-label="preview image"
      >
        <ImageIcon />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2 },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          {label}
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <img
              src={imageUrl}
              alt={label}
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PreviewImageButton;
